<div class="legend-card">
  <div class="legend-header">
    <h4>Status Legend</h4>
  </div>

  <div class="legend-items">
    <div class="legend-item">
      <svg class="status-dot-svg" width="8" height="8" viewBox="0 0 8 8">
        <circle
          cx="4"
          cy="4"
          r="4"
          class="status-dot status-dot-below-capacity"
        />
      </svg>
      <span>Below Capacity - Available for additional assignments</span>
    </div>

    <div class="legend-item">
      <svg class="status-dot-svg" width="8" height="8" viewBox="0 0 8 8">
        <circle
          cx="4"
          cy="4"
          r="4"
          class="status-dot status-dot-not-available"
        />
      </svg>
      <span>Not Available - Out of office or unavailable for assignments</span>
    </div>

    <div class="legend-item">
      <svg class="status-dot-svg" width="8" height="8" viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="4" class="status-dot status-dot-at-capacity" />
      </svg>
      <span
        >At Capacity - Working at full capacity with current assignments</span
      >
    </div>

    <div class="legend-item">
      <svg class="status-dot-svg" width="8" height="8" viewBox="0 0 8 8">
        <circle
          cx="4"
          cy="4"
          r="3"
          fill="white"
          stroke="#9e9e9e"
          stroke-width="2"
          class="status-dot status-dot-unknown"
        />
      </svg>
      <span>Unknown - Capacity status not set</span>
    </div>

    <div class="legend-item">
      <svg class="status-dot-svg" width="8" height="8" viewBox="0 0 8 8">
        <circle
          cx="4"
          cy="4"
          r="4"
          class="status-dot status-dot-over-capacity"
        />
      </svg>
      <span>Over Capacity - Currently overloaded with assignments</span>
    </div>

    <div class="legend-item">
      <svg class="status-dot-svg" width="8" height="8" viewBox="0 0 8 8">
        <defs>
          <linearGradient
            id="legend-mixed-gradient"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stop-color="#68A149" />
            <stop offset="20%" stop-color="#68A149" />
            <stop offset="80%" stop-color="#9f3223" />
            <stop offset="100%" stop-color="#9f3223" />
          </linearGradient>
        </defs>
        <circle
          cx="4"
          cy="4"
          r="4"
          fill="url(#legend-mixed-gradient)"
          class="status-dot status-dot-mixed"
        />
      </svg>
      <span>Mixed - Different statuses across weeks in a period</span>
    </div>
  </div>
</div>
